import React, { FC, SyntheticEvent } from "react";
import classnames from "classnames";
import {SvgIcon} from "../../../SvgIcon/SvgIcon";

interface DayPickerCarouselArrowProps {
  onClick: () => void;
  direction: "prev" | "next";
  disabled?: boolean;
}

export const DayPickerCarouselArrow: FC<DayPickerCarouselArrowProps> = ({
  onClick,
  direction,
  disabled,
}) => {
  const buttonClass = classnames(
    "DayPickerCarouselArrow", 
      {"DayPickerCarouselArrow--left": direction === "prev"},
      {"DayPickerCarouselArrow--right": direction !== "prev"},
      {"DayPickerCarouselArrow--disabled": disabled}
  );

  const handleButtonClick = (e: SyntheticEvent) => {
    e.preventDefault();
    onClick();
  };

  return (
    <button className={buttonClass} onClick={handleButtonClick} type="button" disabled={disabled}>
      <SvgIcon iconName={direction === "prev" ? "chevron-left-thin" : "chevron-right-thin"} className="DayPickerCarouselArrow__icon" />
      <span className="visually-hidden">
        {direction === "prev" ? "Bakover" : "Fremover"}
      </span>
    </button>
  );
};
